import { AloftPrice } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectOpinionOfSiteValue } from './opinionOfSiteValueSelectors.ts';
import { selectImprovementsCost } from './selectImprovementsCost.ts';

export const selectSubjectValue = createSelector(
  [(state) => selectImprovementsCost(state, 'subject'), selectOpinionOfSiteValue],
  (improvements, opinionOfSiteValue) => {
    if (!improvements || !opinionOfSiteValue) return undefined;
    return improvements.add(AloftPrice.schema.parse(opinionOfSiteValue));
  },
);

export const selectSubjectValueDisplay = createSelector([selectSubjectValue], (subjectValue) =>
  subjectValue?.toString(true),
);

export const selectSubjectArvValue = createSelector(
  [(state) => selectImprovementsCost(state, 'subjectArv'), selectOpinionOfSiteValue],
  (improvements, opinionOfSiteValue) => {
    if (!improvements || !opinionOfSiteValue) return undefined;
    return improvements.add(AloftPrice.schema.parse(opinionOfSiteValue));
  },
);

export const selectSubjectArvValueDisplay = createSelector([selectSubjectArvValue], (subjectArvValue) =>
  subjectArvValue?.toString(true),
);
  